/**
 * Compute a hex-encoded SHA-256 hash of the given string.
 * Returns a fixed placeholder when the Web Crypto API is unavailable (e.g. SSR),
 * so callers can distinguish failed hashing from a real hash.
 */
export async function hashSHA256(value: string): Promise<string> {
  if (typeof window === 'undefined' || !window.crypto?.subtle) {
    return 'no-crypto';
  }
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
